import { ReactElement, SVGProps } from 'react'
export const SvgVk = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#vk_svg__a)">
      <path
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
        fill="#0177FF"
      />
      <g clipPath="url(#vk_svg__b)">
        <path
          d="M26.177 11.48c.15-.468 0-.812-.704-.812h-2.335c-.594 0-.866.297-1.015.624 0 0-1.187 2.742-2.869 4.519-.543.517-.79.68-1.087.68-.148 0-.363-.163-.363-.632v-4.378c0-.563-.171-.813-.666-.813h-3.669c-.37 0-.594.26-.594.508 0 .533.841.655.927 2.156v3.254c0 .713-.135.843-.433.843-.79 0-2.716-2.751-3.858-5.901-.223-.612-.447-.859-1.043-.859H6.134c-.668 0-.8.297-.8.624 0 .587.79 3.49 3.684 7.33 1.93 2.623 4.645 4.045 7.12 4.045 1.482 0 1.665-.316 1.665-.86v-1.982c0-.631.142-.758.611-.758.345 0 .94.165 2.324 1.428 1.582 1.498 1.844 2.171 2.733 2.171h2.334c.666 0 1-.316.808-.939-.21-.62-.966-1.522-1.968-2.59-.546-.609-1.36-1.264-1.608-1.592-.346-.422-.246-.609 0-.984.001.001 2.845-3.792 3.14-5.081Z"
          fill="#fff"
        />
      </g>
    </g>
    <defs>
      <clipPath id="vk_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
      <clipPath id="vk_svg__b">
        <path fill="#fff" transform="translate(5.333 5.334)" d="M0 0h21.333v21.333H0z" />
      </clipPath>
    </defs>
  </svg>
)
